import { ScrollArea } from '@praetoid/ui';
import { createFileRoute } from '@tanstack/react-router';

import CaseComponent from '~/app/praetors/cases/Case/Case';

export interface CaseParams {
	thread?: string;
}

export const Route = createFileRoute('/_app/home/praetors/$praetorId/cases/v2/$caseId')({
	validateSearch: (search): CaseParams => {
		return { thread: search.thread } as CaseParams;
	},
	beforeLoad: ({ params: { caseId: _caseId } }) => {
		return {
			getTitle: 'Details'
		};
	},
	component: function PraetorCaseDetail() {
		const { caseId } = Route.useParams();
		return (
			<ScrollArea className="h-full">
				<CaseComponent caseId={caseId} />
			</ScrollArea>
		);
	}
});
